'use client';

import { useMemo, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';

import { Text, Container } from '@weareconceptstudio/core';

import { useGoogleReviews } from '@/libs/hooks';

//* Styles
import ReviewStyle from './style';

//* Components
import Rating from '../RatingAndReview/Rating';
import RatingAndReview from '../RatingAndReview';
import SkeletonSliderReview from './Skeleton';

const Review = () => {
	//! Ref
	const swiperRef = useRef();

	const { data } = useGoogleReviews();

	// All hooks must run before the loading early-return below; calling useMemo
	// only after data arrives changes the hook count between renders (React #310).
	const success = data?.success;
	const reviews = data?.reviews;

	const slideItems = useMemo(() => {
		const reviewsList = Array.isArray(reviews) ? reviews : [];
		return reviewsList.slice(-8).filter((item) => item?.comment && item.comment.length > 10);
	}, [reviews]);

	const itemSlide = useMemo(() => {
		if (!success || slideItems.length === 0) return null;
		return slideItems.map((item, i) => (
				<SwiperSlide key={item?.reviewer?.displayName ?? i}>
					<div className='wrapper-item'>
						<Text className={'title p p3 line-clamp-10'}>{item.comment}</Text>

						<div className='wrapper-ratting-author'>
							<Rating
								showText={false}
								className={'color-reverse'}
								rate_count={item.starRating}
							/>

							<Text className={'p p4 font-montserrat-arm-bold'}>
								{item.reviewer?.displayName ?? ''}
							</Text>
						</div>
					</div>
				</SwiperSlide>
			));
	}, [slideItems, success]);

	if (!data) {
		return <SkeletonSliderReview />;
	}

	return success && slideItems.length > 0 ? (
		<ReviewStyle>
			<Container>
				<div className='wrapper-revive'>
					<Text
						className={'title h2 uppercase'}
						text={'yourOpinionCounts'}
					/>

					<RatingAndReview className={'color-reverse reverse button-auto'} />
				</div>
			</Container>

			<div className='outer-wrapper-swiper'>
				<Swiper
					ref={swiperRef}
					slidesPerView={'auto'}
					loop={true}
					modules={[Autoplay]}
					autoplay={false}
					onSwiper={(swiper) => {
						swiperRef.current = swiper;

						setTimeout(() => {
							if (swiper.autoplay) {
								swiper.autoplay.start();
							}
						}, 10000);
					}}>
					{itemSlide}
				</Swiper>
			</div>
		</ReviewStyle>
	) : null;
};

export default Review;
